(function ($) {
  // Document Ready
  $(document).ready(function () {
    if ($(".team-section").length) {
      console.log("team-modal.js initiated");

      /***************************************************
        Team Modal Handlers
      /*****************************************************/
      const openTeamModal = (event) => {
        const $button = $(event.currentTarget);
        const index = $button.data("index");
        const $memberBio = $(`.member-bio[data-index="${index}"]`);

        // Remove 'show' class from all bios
        $(".member-bio").removeClass("show");

        // Add 'show' class to the clicked bio
        $memberBio.addClass("show");

        // Add 'team-modal-active' class to body
        $("body").addClass("team-modal-active");
        $("#team-modal").attr("aria-hidden", "false").removeAttr("inert");
      };

      const closeTeamModal = () => {
        $("body").removeClass("team-modal-active");
        $("#team-modal").attr("aria-hidden", "true").attr("inert", "");

        // Remove 'show' class from all bios
        $(".member-bio").removeClass("show");
      };

      // Open team modal on button click
      $(".open-modal-btn").on("click", openTeamModal);

      // Close team modal on button click
      $(".close-modal-btn").on("click", closeTeamModal);

      // Close team modal on background click
      $(document).on("click", function (event) {
        if ($("body").hasClass("team-modal-active")) {
          const $target = $(event.target);
          if ($target.closest("#team-modal .container, .open-modal-btn").length === 0) {
            closeTeamModal();
          }
        }
      });

      // Close team modal on ESC key
      $(document).on("keydown", function (e) {
        if (e.key === "Escape" && $("body").hasClass("team-modal-active")) {
          closeTeamModal();
        }
      });
    }
  });
})(jQuery);
